import React from 'react';

const text = {
    page: 'New Section',
    pageDrop: 'Section',
    section: 'Row with Columns',
    row: 'Columns',
    column: 'Element',
    heading: {
        section: 'Drop a Row',
        row: 'Drop a Column',
        column: 'Drop an Element',
    },
};

const ButtonAddNew = ({ onClick, type }) => {
    const btnSize = type === 'page' ? 'btn-primary' : 'btn-primary-alt';
    const heading = text.heading[type];
    return (
        <>
            <button
                onClick={onClick}
                className={`btn btn-2x ${btnSize}`}
                style={{ borderStyle: type !== 'page' ? 'dotted' : '' }}
            >
                + Add {text[type]}
            </button>
        </>
    );
};

export default React.memo(ButtonAddNew);
